import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-6">
      <div className="max-w-2xl bg-black border border-white rounded-lg shadow-xl p-8">
        <div className="flex items-center mb-6">
          <button
            onClick={() => navigate('/')}
            className="w-10 h-10 rounded-full bg-white text-black flex items-center justify-center shadow-md hover:bg-gray-200 transition duration-300 mr-4"
            aria-label="Back to Home"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="text-3xl font-bold text-white">Privacy Policy</h1>
        </div>
        <p className="text-white mb-4">
          At Layne Red, we value your privacy. We collect cookies, phone numbers, addresses, and other sensitive credentials solely for order processing. These details are securely handled through the Envia API.
        </p>
        <p className="text-white">
          We do not share your information with any services other than our trusted courier service, ensuring your data remains protected.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;